import paymentsDashboardConfig from '../mocks/payments-dashboard.json'

export const getPaymentsDashboardConfig = () => paymentsDashboardConfig || {}

export const getPaymentsProfileMenuOverrides = () => paymentsDashboardConfig?.profileMenuOverrides || {}

export const getPaymentsPageConfig = () => {
	const config = getPaymentsDashboardConfig()

	return {
		page: config?.page || {},
		overviewCards: Array.isArray(config?.overviewCards) ? config.overviewCards : [],
		subscription: config?.subscription || {},
		invoices: Array.isArray(config?.invoices) ? config.invoices : [],
		support: config?.support || {},
	}
}